import { Ref } from "react";

/**
 * @deprecated Type-adapter shim from the React 19 upgrade that reconciles
 * legacy Blueprint ref types with React 19's standard `Ref<T>`. It is now a
 * runtime no-op (identity). Prefer removing it once the source props are typed
 * with a React 19-compatible ref; do not add new usages.
 */
export function legacyToStandardRef<T>(
  ref: Ref<T> | undefined,
): Ref<T> | undefined {
  return ref;
}
